import defaultImage from './../../asset/image/ex_img_3.png';
import dateIcon from './../../asset/icons/calender_gray_s.svg';
import feedCoin from './../../asset/icons/rate_ic.svg';
import starIcon from './../../asset/icons/starIcon.svg';
import {DELETE_FOOD, EDIT_FOOD, GET_ALL_FOOD} from '../../helperData/ApiAddress';
import {useEffect, useState} from 'react';
import {del, get, patch} from "../../controlers/global/ConfigRequest";
import PaginationComponent from '../../component/global/PaginationComponent';
import {Spinner} from 'react-bootstrap';
import {useNavigate} from 'react-router-dom';
import SwitchButton from '../../component/global/SwitchButton';
import {useTranslation} from "react-i18next";


export default function Food() {

  const history = useNavigate();
  const {t} = useTranslation()

  const [basket, setBasket] = useState(undefined);
  const [page, setPage] = useState("1");
  const [deleteLoader, setDeleteLoader] = useState(false);

  const getBasket = () => {
    var url = new URL(GET_ALL_FOOD);
    url.searchParams.set("page", page);

    get(url).then(r => {
      setBasket(r)
    })
  }
  useEffect(getBasket, [page])

  const basketDeleteHandle = id => {
    setDeleteLoader(id);
    del(DELETE_FOOD.replace(":id", id)).then(r => {
      getBasket();
    })
      .finally(_ => {
        setDeleteLoader(false);
      })
  }

  const activeToggle = (i, e, status) => {
    console.log(i, e)
    patch(EDIT_FOOD.replace(":id", i), {
      active: status
    })
  }

  return (
    <div className="food-section">
      <div className="food-table">
        <div class="header">
          <div>
            &nbsp;
          </div>
          <div>
            {t('Src.Pages.Food.FoodJs.Product.Label')}
          </div>
          <div>
            {t('Src.Pages.Food.FoodJs.Date.Label')}
          </div>
          {/* <div>
                    پلن‌ها
                </div> */}
          <div>
            {t('Src.Pages.Food.FoodJs.Feed.Coin.Label')}
          </div>
          <div>
            {t('Src.Pages.Food.FoodJs.Rate.Label')}
          </div>
          <div>
            {t('Src.Pages.Food.FoodJs.Function.Label')}
          </div>
        </div>
        {
          basket
            ?
            basket.results.length > 0
              ?
              basket.results.map((item, index) => (
                <div key={index}>
                  <div>
                    <img className='preview' src={defaultImage} alt=""/>
                  </div>
                  <div>
                    {item.item_name}
                  </div>
                  <div>
                    <img src={dateIcon} alt=""/>
                    <span>1400/12/12</span>
                  </div>
                  {/* <div>
                                    4
                                </div> */}
                  <div>
                    <img src={feedCoin} alt=""/>
                    <span>{item.coin}</span>
                  </div>
                  <div>
                    <img src={starIcon} alt=""/>
                    <span>{(Math.round(item.computed_score * 10) / 10).toString().replace(".", "/")}</span>
                  </div>
                  <div>
                    <SwitchButton
                      defaultStatus={item.active}
                      toggleFunction={activeToggle}
                      selectedRow={item.id}
                    />
                  </div>
                  <div>
                    <button
                      className='button primary'
                      onClick={_ => history("/dashboard/food/form/" + item.id)}
                    >
                      {t('Src.Pages.Food.FoodJs.Edit.Label')}
                    </button>
                    <button
                      className='button delete'
                      onClick={_ => basketDeleteHandle(item.id)}
                    >
                      {
                        deleteLoader === item.id
                          ?
                          <div className="spinner-border-con">
                            <Spinner animation='border'/>
                          </div>
                          :
                          <div>{t('Src.Pages.Food.FoodJs.Remove.Label')}</div>
                      }
                    </button>
                  </div>
                </div>
              ))
              :
              <span className='empty-basket'>{t('Src.Pages.Food.Not.Found')}</span>
            :
            <Spinner animation='border'/>
        }
      </div>

      {
        basket?.count > 20 &&
        <PaginationComponent
          currentPage={page - 1}
          pageCount={Math.ceil(basket.count / 20)}
          fetchData={e => setPage(e.pageIndex + 1)}
          feedbacks={basket.results}
        />
      }
    </div>
  )
}
